<template>
  <div>

    <v-container grid-list-xl fluid :class="{'mobile-card': $vuetify.breakpoint.xsOnly}"
                 :is="$vuetify.breakpoint.xsOnly ? 'div' : 'v-container'">

      <v-layout row wrap>

        <v-flex xs12 sm10 offset-sm1>

          <v-card>
            <v-flex xs12 :class="{'logo-mobile': $vuetify.breakpoint.xsOnly}" v-if="$vuetify.breakpoint.xsOnly">
              <img src="../../assets/logotj.png" style="margin-top: 5px;">
              <p><b>Consulta Pública de Atos e Selos</b></p>
            </v-flex>

            <v-flex xs12 lg11 v-else>
              <img src="../../assets/LogoTJROD.png">
            </v-flex>
            <v-divider light></v-divider>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex md12>
                        <v-card color="blue lighten-5 hidden-xs-only">
                          <v-card-text style="text-align: justify">
                            A remessa das informações relativas aos Selos de Fiscalização utilizados e aos respectivos
                            atos
                            notariais e de registro será realizada diariamente, até o dia útil imediatamente subsequente
                            ao
                            da
                            prática dos atos, nos termos do § 1º do Art. 126, das Diretrizes Gerais Extrajudiciais.
                          </v-card-text>
                        </v-card>
                      </v-flex>

                      <v-flex xs12 md6>
                        <div style="margin-top: 20px"></div>
                        <form-busca-selo @submit="onSubmit"></form-busca-selo>
                      </v-flex>

                      <v-flex xs12 md6 v-if="QrReaderlowLevelCompatibilityCheck()">
                        <qrcode-reader ref="QrReader" @capture="onQRCapture" :paused="pauseCamera"></qrcode-reader>
                      </v-flex>

                    </v-layout>
                  </v-card-text>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

  </div>
</template>

<script>
  import FormBuscaSelo from './FormBuscaSelo';
  import QrCodeReader from './QrCodeReader';
  import SeloService from '../../domain/selo/selo-service';

  export default {
    components: {
      'form-busca-selo': FormBuscaSelo,
      'qrcode-reader': QrCodeReader
    },
    data: function () {
      return {
        service: null,
        pauseCamera: false
      };
    },
    created: function () {
      this.service = new SeloService(this.$resource);
    },
    methods: {
      onSubmit(form) {
        let self = this;
        let promise;
        if (form.tipo === 9) {
          try {
            const codigo = form.codigo.substring(0, 10);
            const hash = form.codigo.substring(10, 15);
            promise = this.service.buscarPorHash(codigo, hash)
          } catch (e) {
            self.onError(e);
          }
        }
        else {
          promise = this.service.buscarPorTipo(form.codigo, form.tipo)
        }
        promise.then(selo => {
          let query = {};
          if (form.tipo === 9) {
            query.codigo = form.codigo.substring(0, 10);
            query.hash = form.codigo.substring(10, 15);
          }
          else {
            query.codigo = form.codigo;
            query.tipo = form.tipo;
          }
          self.$router.push({
            name: 'DetalhesSelo',
            query: query,
            params: {preloadedSelo: selo}
          });
        }).catch(self.onError);
      },
      QrReaderlowLevelCompatibilityCheck: function () {
        return "mediaDevices" in navigator;
      },
      onQRCapture(payload) {
        this.pauseCamera = true;
        try {
          const code = payload.code.substring(payload.code.indexOf('?'));
          const params = new URLSearchParams(code);
          const query = {
            codigo: params.get('codigo'),
            hash: params.get('hash')
          };
          if (!query.codigo || !query.hash) throw new Error('codigo_invalido');
          else {
            let self = this;
            let promises = [
              self.$refs.QrReader.flash('success'),
              // this.notify.success(this, `Código ${query.codigo}`, 'Código QR válido', 3500),
              self.service.buscarPorHash(query.codigo, query.hash)
            ];

            Promise.all(promises).then((data) => {
              let selo = data[1];
              self.$router.push({
                name: 'DetalhesSelo',
                query: {codigo: query.codigo, hash: query.hash},
                params: {preloadedSelo: selo}
              });
            }).catch(self.onError);

          }
        } catch (error) {
          let self = this;
          self.notify.error(self, 'Não foi possível identificar o código QR. Tente consultar o selo manualmente.', 'Código QR inválido', 7000);
          self.$refs.QrReader.flash('fail');
          setTimeout(() => self.pauseCamera = false, 600);
        }
      },
      onError(error) {
        let message;
        let self = this;
        switch (error.status) {
          case 0:
            message = error.message || 'Serviço indisponível.';
            break;
          case 404:
            message = error.message || 'Recurso não encontrado.';
            break;
          case 500:
            message = 'Erro interno.';
            break;
          default:
            message = 'Erro inesperado.';
        }
        console.log(error);
        self.notify.error(self, message, 'Ocorreu um erro', 7000);
        setTimeout(() => self.pauseCamera = false, 600);
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .logo-mobile{
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/consulta/Consulta.vue